var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: "POLICY_MANAGEMENT",
          expression: "'POLICY_MANAGEMENT'",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c(
        "div",
        {
          staticClass: "bs-table-custom-toolbar",
          attrs: { id: "licenseGroupsToolbar" },
        },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.createLicenseGroupModal",
                  modifiers: { createLicenseGroupModal: true },
                },
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: _vm.PERMISSIONS.POLICY_MANAGEMENT,
                  expression: "PERMISSIONS.POLICY_MANAGEMENT",
                },
              ],
              attrs: { size: "md", variant: "outline-primary" },
            },
            [
              _c("span", { staticClass: "fa fa-plus" }),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.create_license_group")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: { "on-load-success": _vm.tableLoaded },
      }),
      _c("create-license-group-modal", {
        on: { refreshTable: _vm.refreshTable },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }